import React, { FC } from 'react';
import './NoMenuLayout.scss';

const NoMenuLayout: FC = ({ children }) => <div className="no-menu-wrapper">{children}</div>;

export default NoMenuLayout;
